import React from 'react';
var Modal = require("components/utility/AltModal");

require("appdev/wizards/setup_checklist_modal.scss")
var Glyphicon = require("components/utility/icons/Glyphicon");

class SetupChecklistModal extends React.Component {
    constructor(props) {
        super();
        autobind(this);
    }

    //////// MODAL CONTROLS ACTIONS ///////

    show() {
        this.refs.modal.show();
    }

    ////////////// RENDER METHODS //////////////

    renderChecklist(){
        console.log(this.props.districtOrg)
        if (!this.props.districtOrg || !this.props.districtOrg.setup_checklist) { return }
        
        if (this.props.districtOrg.setup_checklist.unprovisioned_account){
            return <h4> District has not been provisioned yet</h4>
        }
        var items = Object.keys(this.props.districtOrg.setup_checklist)
        
        return (
            <div className='checklist'>
                {items.map(item=>{
                    var passed = this.props.districtOrg.setup_checklist[item] 
                    var className = passed ? "passed" : "failed"
                    className += " checklistItem"
                    return (
                        <div className={className}>
                            {DISPLAY_NAMES[item][passed]}
                        </div>
                    )
                })}
            </div>
        )
    }

    renderFailedContain

    render() {
        return (
            <div className="setupChecklistModal">
                <Modal headerText="Setup Checklist" ref="modal">
                    {this.renderChecklist()}
                </Modal>
            </div>
        )
    }

    
};

const DISPLAY_NAMES = {
    all_sls_have_admin: {true: "All student lists have primary admin", false: "At least one student list doesn't have a primary admin"},
    all_upgraded_teachers: {true: "All teachers are wrGold", false: "Not all teachers are wrGold"},
    correct_org_links: {true: "Every user is linked to the correct orgs", false: "Not every user is linked to the correct orgs"},
    no_archived_lists: {true: "There are no incorrectly archived student lists", false: "There are incorrectly archived student lists"},
    student_clever_users: {true: "Each student is mapped to a Clever user", false: "Some students are mapped incorrectly to Clever users"},
    teacher_clever_users: {true: "Each teacher is mapped to a Clever user", false: "Some teachers are mapped incorrectly to Clever users"},
    all_students_have_primary_sl: {true: "Each student has a primary student list", false: "Not all students have a primary student list"},
    no_students_suspended: {true: "There are no suspended students", false: "There are some suspended students"},
    have_all_terms: {true: "There are no terms missing", false: "There are some missing terms"},
    all_sections_have_sls:{true: "All sections have student lists", false: "Not all sections have student lists"},
    no_missing_teachers: {true:"There are no missing teachers", false: "There are some missing teachers"},
    no_duplicate_teachers:{true: "There are no duplicate teachers", false: "There are some duplicate teachers"}
}

SetupChecklistModal.propTypes = StrictPropTypes({
    districtOrg: PropTypes.object,
});

module.exports = SetupChecklistModal;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/SetupChecklistModal.js